(() => {
  if (document.documentElement.hasAttribute('data-os-delivery-ready')) return;
  document.documentElement.setAttribute('data-os-delivery-ready', '');
  const openers = new WeakMap();
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-os-delivery-open], [data-os-info-open]');
    const dialog = trigger
      ? document.getElementById(trigger.dataset.osInfoOpen || 'OsDeliveryDialog')
      : event.target.closest('dialog.os-delivery-dialog[open]');
    if (!dialog) return;
    if (trigger) {
      if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (dialog.open) return;
      document.querySelectorAll('[data-os-menu][open]').forEach(menu => { menu.open = false; });
      const mobileMenu = document.getElementById('OsMobileMenu');
      if (mobileMenu?.open) mobileMenu.close();
      openers.set(dialog, trigger);
      dialog.showModal();
      dialog.scrollTop = 0;
      document.body.classList.add('os-delivery-open');
      dialog.querySelector('[data-os-delivery-close]').focus();
      return;
    }
    if (!dialog.open) return;
    if (event.target.closest('[data-os-delivery-close]')) dialog.close();
    if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });
  document.addEventListener('keydown', event => {
    const dialog = document.querySelector('dialog.os-delivery-dialog[open]');
    if (event.key !== 'Tab' || !dialog?.open) return;
    const controls = [...dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')].filter(control => control.getClientRects().length);
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  document.addEventListener('close', event => {
    if (!(event.target instanceof Element) || !event.target.matches('dialog.os-delivery-dialog')) return;
    if (!document.querySelector('dialog.os-delivery-dialog[open]')) document.body.classList.remove('os-delivery-open');
    const opener = openers.get(event.target);
    if (opener?.isConnected) opener.focus();
  }, true);
})();
